import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { RegisterComponent } from "./RegisterComponent";
import { register } from "../actions";
import {
  setWarningMessage,
  setSuccessMessage
} from "../../../messages/actions";

import { translate } from "react-i18next";

const mapStateToProps = state => {
  return {
    phase: state.account.phase
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSubmit: values => {
      if (!values) return;

      if (!values.email) {
        dispatch(setWarningMessage("Email can't be empty"));
        return;
      }
      if (!values.password) {
        dispatch(setWarningMessage("Password can't be empty"));
        return;
      }
      if (!values.confirmpassword) {
        dispatch(setWarningMessage("Confirm password can't be empty"));
        return;
      }

      if (values.password !== values.confirmpassword) {
        dispatch(setWarningMessage("Passwords must match"));
        return;
      }

      dispatch(register(values)).then(() =>
        setSuccessMessage("Check your e-mail")
      );
    }
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "register"
  })(translate("translations")(RegisterComponent))
);



// WEBPACK FOOTER //
// ./src/users/loggedUser/Register/index.js